var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('w-btn',{attrs:{"color":_vm.error ? 'red' : 'blue',"loading":_vm.loading,"disabled":_vm.disabled,"text":_vm.$t('common.back'),"icon":_vm.error ? 'mdi-alert' : 'mdi-page-previous'},on:{"press":_setup.press}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }